<template>
  <section>
    <div class="container">
      <div class="search-box">
        <el-input class="control-box-input" style="width:217px;" v-model="params.name" placeholder="请输入场所名称"
          clearable></el-input>
        <el-select v-model="params.province_id" placeholder="请选择省份" style="margin-left:10px;width:150px;" clearable
          @change="provinceClick()">
          <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="params.city_id" placeholder="请选择市" clearable style="margin-left:10px;width:150px;"
          @change="cityClick()">
          <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="params.area_id" placeholder="请选择地区" clearable style="margin-left:10px;width:150px;"
          @change="areaClick()">
          <el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-input class="control-box-input" v-model="params.market" style="margin-left:10px;" placeholder="请输入市场负责人"
          clearable></el-input>
        <el-button icon="el-icon-search" @click="searchData" style="margin-left:10px;">搜索</el-button>
        <el-button icon="el-icon-plus" type="primary" @click="handleOpenAdd">添加投放点</el-button>
      </div>
      <div class="table-box">
        <div class="data-box">
          <el-row :gutter="20" style="width:100%">
            <el-col :span="6" v-for="(value, key) in table" style="margin-bottom: 10px;">
              <div class="list">
                <div class="list-top">
                  <div class="list-top-avatar">
                    <el-avatar v-if="value.image" :src="value.image"></el-avatar>
                    <el-avatar v-else icon="iconfont icon-gujianzhu11"></el-avatar>
                  </div>
                  <div class="list-top-info">
                    <div class="list-top-info-name">{{ value.name }}</div>
                    <div class="list-top-info-area">
                      <i class="iconfont icon-tubiao-"></i>
                      {{ value.province_name }} {{ value.city_name }} {{ value.area_name }}
                    </div>
                  </div>
                  <div class="list-top-code">
                    <i class="iconfont icon-qrcode"></i>
                  </div>
                </div>
                <div class="list-content">
                  <div class="list-content-info">
                    <el-descriptions title="" :column="2" size="small">
                      <el-descriptions-item label="大殿数">{{ value.halls }}</el-descriptions-item>
                      <el-descriptions-item label="联系方式">{{ value.tel ? value.tel : '-' }}</el-descriptions-item>
                      <el-descriptions-item label="类别">
                        <el-tag size="mini" type="info" v-if="value.religious_type === 0">道</el-tag>
                        <el-tag size="mini" v-if="value.religious_type === 1">佛</el-tag>
                      </el-descriptions-item>
                      <el-descriptions-item label="等级">
                        <span v-if="value.place_type === 0">普通商业场所</span>
                        <span v-if="value.place_type === 1">宗教活动场所</span>
                        <span v-if="value.place_type === 2">民间信仰点</span>
                      </el-descriptions-item>
                      <el-descriptions-item label="市场负责人" :span="2">
                        <el-popover v-if="value.agent.name"
                          placement="top-start"
                          trigger="hover">
                          <div slot="reference" class="agent-name">
                            <el-tag size="mini" type="info">{{value.agent.name}}</el-tag>
                          </div>
                          <div class="agent-box">
                            <el-descriptions :column="1" size="mini" title="市场负责">
                              <el-descriptions-item label="姓名">{{ value.agent.name }}</el-descriptions-item>
                              <el-descriptions-item label="联系电话">{{ value.agent.phone }}</el-descriptions-item>
                            </el-descriptions>
                          </div>
                        </el-popover>
                        <span v-else> - </span>
                      </el-descriptions-item>
                      <el-descriptions-item label="联系地址">{{ value.address }}</el-descriptions-item>
                    </el-descriptions>
                  </div>
                  <div class="list-content-product">
                    <el-row :gutter="20">
                      <el-col :span="8">
                        <div class="product-list">
                          <div class="product-list-title"><i class="iconfont icon-candlesstick"></i>智能烛台</div>
                          <div class="product-list-count">{{ value.product.multi }}</div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="product-list">
                          <div class="product-list-title"><i class="iconfont icon-kongzhiqi"></i>控灯控烛</div>
                          <div class="product-list-count">{{ value.product.control }}</div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="product-list">
                          <div class="product-list-title"><i class="iconfont icon-quanbufenzu"></i>场景祈福
                          </div>
                          <div class="product-list-count">{{ value.product.combo }}</div>
                        </div>
                      </el-col>
                       <el-col :span="8">
                        <div class="product-list">
                          <div class="product-list-title"><i class="iconfont icon-zhihuichengshilianghuaxitong"></i>点亮场所
                          </div>
                          <div class="product-list-count">{{ value.product.building }}</div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="product-list">
                          <div class="product-list-title"><i class="iconfont icon-computer-full"></i>显示设备
                          </div>
                          <div class="product-list-count">{{ value.product.display }}</div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="product-list">
                          <div class="product-list-title"><i class="iconfont icon-qita"></i>其他设备
                          </div>
                          <div class="product-list-count">{{ value.product.other }}</div>
                        </div>
                      </el-col>
                    </el-row>

                    <el-row :gutter="30" style="margin-top:10px;">
                      <el-col :span="12">
                        <div class="product-list project">
                          <div class="product-list-title"><i class="iconfont icon-shouye"></i>智能龛位</div>
                          <div class="product-list-count">{{ value.project.niche.bought }} / {{ value.project.niche.total }}</div>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="product-list project">
                          <div class="product-list-title"><i class="iconfont icon-paiwei-xuanze"></i>延生禄位</div>
                          <div class="product-list-count">{{ value.project['m-tablet'].bought }} / {{ value.project['m-tablet'].total }}</div>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="product-list project">
                          <div class="product-list-title"><i class="iconfont icon-paiwei-xuanze"></i>往生牌位</div>
                          <div class="product-list-count">{{ value.project['p-tablet'].bought }} / {{ value.project['p-tablet'].total }}</div>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="product-list project">
                          <div class="product-list-title"><i class="iconfont icon-qitashebei"></i>其他龛牌</div>
                          <div class="product-list-count">{{ value.project.other.bought }} / {{ value.project.other.total }}</div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div class="list-remark">
                  <el-tooltip placement="top-start" effect="light" v-if="value.remark">
                    <div slot="content" style="width: 300px;line-height: 24px;">{{ value.remark }}</div>
                    <span>备注：{{ value.remark }}</span>
                  </el-tooltip>
                  <span v-else>备注：-</span>
                </div>
                <div class="list-footer">
                  <el-button type="primary" plain size="mini" @click="editTable(value.id)"><i
                      class="iconfont icon-bianji"></i>编辑</el-button>
                  <el-button type="info" plain size="mini" @click="goDetail(value.id)"><i
                      class="iconfont icon-detail"></i>详情</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="page-box">
          <!-- <div class="word">可提现总金额:  <span>{{total_amount}}</span></div> -->
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="params.page"
            :hide-on-single-page="false" :small="true" :page-size="params.page_count"
            layout="total, prev, pager, next,jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>


    <el-drawer title="更改投放点信息" :visible.sync="editDrawer" :direction="direction" :before-close="handleClose">
      <edit-comp v-if="editDrawer" @close="handleClose" @success="handleDrawerSuccess" :id="editID"
        ref="newForm"></edit-comp>
    </el-drawer>

    <!-- 添加规则 -->
    <el-drawer title="添加投放点" :visible.sync="addDrawer" :direction="direction" :before-close="handleClose">
      <add-comp @close="handleClose" @success="handleDrawerSuccess" @clear="clearContent" ref="newForm"
        v-if="addDrawer"></add-comp>
    </el-drawer>

    <el-drawer title="查看详情" :visible.sync="detailDrawer" :direction="direction" size="900px" style="overflow-y: auto;"
      :before-close="handleClose">
      <detail-comp v-if="detailDrawer" @close="handleClose" @success="handleDrawerSuccess" :id="detailID" ref="newForm">
      </detail-comp>
    </el-drawer>
  </section>
</template>

<script>
import { getList, addData, editData, getTypeList, editPrice, editDevided, deleteData, storeAppointment, storeRefuse, updateDeduction, getMedia, editMedia } from "@/api/store.js";
import { getProvince, getCity, getArea } from "@/api/public.js";
import { getGroups } from "@/api/system.js";
import addComp from "./components/add.vue";
import editComp from "./components/edit.vue";
import detailComp from "./components/detail.vue";
let page_name = 'place_list'
export default {
  name: "App",
  components: { addComp, editComp, detailComp },

  data() {
    return {
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      reason: '',
      admin_permission: [],
      dialogVisible: false,
      dialogPerVisible: false,
      dialogTableVisible: false,
      dialogRefuseVisible: false,

      provinceList: [],
      cityList: [],
      areaList: [],
      province_id: "",
      city_id: "",
      params: {
        page: 1,
        page_count: 12,
        username: '',
        gender: '',
        mobile: '',
        status: '',
        nickname: '',
        province_id: '',
        city_id: '',
        area_id: '',
        group_id: '',
        store_type: '',
        lay_type: '',
        store_size: '',
        market: ''
      },
      groupList: [],
      groupID: '',
      table: [],

      editID: '',
      detailID: 0,
      total: 0,
      outerVisible: false,
      innerVisible: false,
      addDrawer: false,
      editDrawer: false,
      detailDrawer: false,
      direction: "rtl",
      addTradeParams: {
        name: "",
        parent_id: 0
      },
      visible: false,
      scopeForm: {
        id: '',
        sort: ''
      }
    };
  },

  mounted() {
    this.admin_permission = this.$store.state.permission.permissionArr[page_name]
    this.getTableData();
    this.searchType();

    this.groupID = this.$store.state.user.userData.group_id
    getGroups().then(res => {
      if (res.code === 200) {
        this.groupList = res.data
      }
    })
    getProvince().then(res => {
      if (res.code === 200) {
        this.provinceList = res.data
      }
    })
  },

  methods: {
    getTableData() {
      getList(this.params).then(res => {
        if (res.code === 200) {
          this.table = res.data.data
          console.log(this.table)
          this.params.page = res.data.current_page
          this.params.page_count = res.data.per_page
          this.total = res.data.total
        }
      })
    },
    searchData() {
      this.params.page = 1
      this.getTableData()
    },
    searchType() {
      getTypeList().then(res => {
        if (res.code === 200) {
          this.storeTypeOptions = res.data
          console.log(this.storeTypeOptions)
        }
      })
    },
    handleOpenAdd() {
      this.addDrawer = true;
    },
    provinceClick() {
      let that = this
      this.provinceList.forEach(item => {
        if (item.id == that.params.province_id) {
          that.province_id = item.province_id
          console.log(that.province_id)
        }
      });
      getCity(that.province_id).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          this.cityList = res.data
        }
      })
    },
    cityClick() {
      let that = this
      this.cityList.forEach(item => {
        if (item.id == that.params.city_id) {
          that.city_id = item.city_id
          console.log(that.city_id)
        }
      });
      getArea(that.city_id).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          this.areaList = res.data
        }
      })
    },
    goDetail(id) {
      this.detailID = id
      this.detailDrawer = true
    },
    editTable(id) {
      this.editID = id
      this.editDrawer = true
    },
    // 添加/修改成功
    handleDrawerSuccess() {
      this.getTableData()
      this.addDrawer = false;
      this.editDrawer = false;
      // this.searchSet()
      this.$refs.newForm.$refs.form.resetFields();
    },
    // 清空子组件
    clearContent() {
      this.$refs.newForm.$refs.form.resetFields();
    },
    // 分页
    prevpage() {
      this.params.page -= 1;
      this.getTableData();
    },
    nextpage() {
      this.params.page += 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.params.page = val;
      this.getTableData();
    },
  }
};
</script>

<style scoped lang="scss">
@import "@/static/default";

.container {
  width: 100%;
  height: 100%;
  background-color: #fff !important;
  box-sizing: border-box;
  padding: 20px;
  padding-bottom: 0;
  display: inline-flex;
  flex-flow: column;
  justify-content: space-between;

  .search-box {
    width: 100%;
    flex-shrink: 0;
    display: inline-flex;

    .control-box-input {
      width: 200px;
    }
  }

  .table-box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 10px;
    flex-shrink: 1;
    display: inline-flex;
    flex-flow: column;
    justify-content: space-between;
    overflow: hidden;

    .data-box{
      width: 100%;
      height: calc(100% - 60px);
      overflow-y: auto;
    }

    .page-box{
      width:100%;
      display:flex;
      justify-content: 
      flex-end;box-sizing: 
      border-box;
      padding: 10px;
      flex-shrink: 0;
    }

    .el-tabs__header {
      margin: 0 !important;
    }
  }

  .toolbar {
    background: #fff;
    width: 100%;
    padding: 16px 32px 26px 0;
  }
}

.list {
  background: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 20px;
  position: relative;
  box-shadow: 0px 2px 8px 0px rgba(0, 21, 41, 0.15);

  &-top {
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding-bottom: 20px;
    border-bottom: 1px solid #e5e9f0;

    &-avatar {
      flex-shrink: 0;
    }

    &-code {
      flex-shrink: 0;

      .iconfont {
        font-size: 30px;
        color: #737b83;
      }
    }

    &-info {
      width: 100%;
      flex-shrink: 1;
      margin-left: 20px;

      &-name {
        font-size: 16px;
        font-weight: bold;
      }

      &-area {
        margin-top: 5px;
        font-size: 14px;
        color: #666;
        display: inline-flex;
        align-items: center;

        .iconfont {
          display: block;
          margin-left: -5px;
          font-size: 24px;
          color: #FFC14B;
        }
      }
    }
  }

  &-content {
    width: 100%;
    box-sizing: border-box;
    padding-top: 20px;

    &-product {
      margin-top: 20px;
      width: 100%;

      .el-col {
        border-right: 1px solid #e5e9f0;
      }

      .el-col:last-of-type {
        border: none;
      }

      .product-list {
        width: 100%;
        display: inline-flex;
        justify-content: space-between;

        &-title {
          display: inline-flex;
          align-items: center;
          font-size: 12px;
          color: #666;

          .iconfont {
            display: block;
            color: #FFC14B;
            margin-right: 5px;
          }
        }

        &-count {
          font-size: 12px;
        }
      }

      .project {
        .iconfont {
          display: block;
          color: #409EFF;
          margin-right: 5px;
        }
      }
    }
  }
  &-remark{
    width: 100%;
    margin-top: 20px;
    box-sizing: border-box;
    padding-top: 10px;
    border-top: 1px solid #e5e9f0;
    font-size: 12px;
    color:#737b83;
    height: 30px;
    overflow: hidden; /*超出的隐藏*/
    white-space: nowrap;
    text-overflow:ellipsis; /*超出的设置为省略号*/
  }
  &-footer {
    box-sizing: border-box;
    padding-top: 20px;
    display: inline-flex;
    width: 100%;
    justify-content: flex-end;

    .iconfont {
      font-size: 12px;
      margin-right: 5px;
    }
  }
}
.agent-name{
  display:inline-flex;
  align-items: center;
  .el-avatar{
    margin-right: 10px;
  }
}
.agent-box{
  width: 300px;
}
</style>
